/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { TextInputSkeleton, TextInput } from "@carbon/react";
import { i18nContext } from "../../table-context";
export default function AppConfigCollectionValue(_ref) {
  var collectionProperty = _ref.collectionProperty,
    isLoading = _ref.isLoading;
  var i18n = useContext(i18nContext);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(TextInputSkeleton, {
      className: "cds--form-item",
      hideLabel: true
    });
  }
  if (collectionProperty !== null && collectionProperty !== void 0 && collectionProperty.value) {
    return /*#__PURE__*/React.createElement(TextInput, {
      className: "ocr--property-text-readonly",
      id: "property-panel-appconfig-collection",
      light: true,
      readOnly: true,
      labelText: i18n.messages.propertyAppConfigCollectionLabel,
      value: collectionProperty.value
    });
  }
  return null;
}